module.exports = __webpack_public_path__ + "media/images/sites/health/favicon-76x76-71f1a470f9a159c758e202b7aad8e3f2.png";